/* Zweiter Duft −10 % (24.10.2026): waehlt im Warenkorb die 4 Kacheln aus snippets/fragrens-montale-upsell.liquid.
   Reihenfolge: Duft aus dem Warenkorb und feste Partner (data-fg-fest), dann zuletzt angesehene
   Montale/Mancera-Duefte, dann Zufall. Die Zufallsreihenfolge bleibt fuer die Sitzung gleich,
   damit die Kacheln beim Aendern der Menge nicht springen.
   Angesehene Duefte merkt sich layout/theme.liquid auf der Produktseite (localStorage). */
(() => {
  const GESEHEN = 'fg-zweiter-duft-gesehen';
  const ZUFALL = 'fg-zweiter-duft-zufall';

  const lesen = (speicher, schluessel) => {
    try {
      return JSON.parse(speicher.getItem(schluessel) || 'null');
    } catch (e) {
      return null;
    }
  };

  const schreiben = (speicher, schluessel, wert) => {
    try {
      speicher.setItem(schluessel, JSON.stringify(wert));
    } catch (e) {
      /* privater Modus: dann eben ohne Gedaechtnis */
    }
  };

  const mischen = (liste) => {
    for (let i = liste.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [liste[i], liste[j]] = [liste[j], liste[i]];
    }
    return liste;
  };

  class FragrensZweiterDuft extends HTMLElement {
    connectedCallback() {
      const liste = this.querySelector('ul');
      if (!liste) return;

      const max = Number(this.dataset.max) || 4;
      const kacheln = [...liste.children].filter((k) => k.dataset.fgHandle);
      const nachHandle = new Map(kacheln.map((k) => [k.dataset.fgHandle, k]));

      const gesehen = (lesen(window.localStorage, GESEHEN) || []).filter((h) => nachHandle.has(h));

      let zufall = (lesen(window.sessionStorage, ZUFALL) || []).filter((h) => typeof h === 'string');
      const neu = kacheln.map((k) => k.dataset.fgHandle).filter((h) => !zufall.includes(h));
      if (neu.length) {
        zufall = zufall.concat(mischen(neu));
        schreiben(window.sessionStorage, ZUFALL, zufall);
      }

      const reihenfolge = [];
      const dazu = (kachel) => {
        if (kachel && !reihenfolge.includes(kachel)) reihenfolge.push(kachel);
      };
      kacheln.filter((k) => k.hasAttribute('data-fg-fest')).forEach(dazu);
      gesehen.forEach((h) => dazu(nachHandle.get(h)));
      zufall.forEach((h) => dazu(nachHandle.get(h)));
      kacheln.forEach(dazu);

      reihenfolge.forEach((kachel, i) => {
        kachel.hidden = i >= max;
        liste.appendChild(kachel);
      });

      this.closest('[data-proben]')?.style.setProperty('--proben-count', String(Math.min(max, reihenfolge.length)));
    }
  }

  if (!customElements.get('fragrens-zweiter-duft')) {
    customElements.define('fragrens-zweiter-duft', FragrensZweiterDuft);
  }
})();
